/**
 * @generated SignedSource<<e3376fef227c6af4580f8dfc3383d8af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type messageHelpers_expiringPromotion$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ExpiringPromoMessage_promotion" | "expiringPromoMessageHelpers_expiringPromotion">;
  readonly " $fragmentType": "messageHelpers_expiringPromotion";
};
export type messageHelpers_expiringPromotion$key = {
  readonly " $data"?: messageHelpers_expiringPromotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_expiringPromotion">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "messageHelpers_expiringPromotion"
};

(node as any).hash = "9ebe4f28228eef8f982551beb52d4239";

export default node;
